module.exports = "img/flags/SO.11ac77a.png";